import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver marked the unit as making a yard move.
 */
export const yardMoveV1 = tmsEventKind(
  { category: "specialDriving", kind: "yardMove", version: 1 },
  { refs: dutyStatusChangeRefs, facts: {} },
);

export const YardMoveV1Schema = yardMoveV1.schema;
export const YardMoveV1FactsSchema = yardMoveV1.facts;

export type YardMoveV1 = z.infer<typeof YardMoveV1Schema>;
export type YardMoveV1Facts = z.infer<typeof YardMoveV1FactsSchema>;

/** Every version of `yardMove`, keyed by version. What `catalog.ts` places under `specialDriving`. */
export const yardMove = { 1: yardMoveV1 } as const;
